import React, { useState } from "react";

import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { CreateIcon } from "../../../components/common/iconography";
import { useHistory } from "react-router-dom";
import { AiIcon } from "../../../components/common/iconography";
import ContentAdd from "@material-ui/icons/Add";
import { BetaBadge } from "../../../components/common/FeatureBadges";

// on click rediirect to create page and pass the resource to the create page
const CreateMenuItem = ({ label, icon, children, disabled, handleClick }) => {
  return (
    <MenuItem disabled={disabled} onClick={handleClick}>
      {icon && <ListItemIcon style={{ minWidth: 32 }}>{icon}</ListItemIcon>}
      <ListItemText primary={label} />
      {children}
    </MenuItem>
  );
};

const CreateMenuButton = ({ resource, disabled, sit = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateShipment = () => {
    history.push({
      pathname: `/inboundShipments/create`,
      state: { sit },
    });
  };

  const handleCreateAdvice = () => {
    // return;
    const location = {
      pathname: `/inboundShipments/create`,
      search: "?advice",
      state: {
        entryPoint: "advices",
        sit,
      },
    };
    history.push(location);
  };

  // ADVICE is not offered for SIT shipments. With INBOUND as the only remaining
  // option, skip the dropdown and render a plain Create button.
  if (sit) {
    return (
      <Button
        id="create-button"
        onClick={handleCreateShipment}
        color="primary"
        size="small"
        disabled={disabled}
        startIcon={<CreateIcon />}
      >
        Create
      </Button>
    );
  }

  return (
    <>
      <Button
        id="create-button"
        aria-controls={open ? "create-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="primary"
        size="small"
        disabled={disabled}
        startIcon={<CreateIcon />}
      >
        Create
      </Button>

      <Menu
        id="create-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        getContentAnchorEl={null}
      >
        <CreateMenuItem
          label={
            <span>
              ADVICE
              <BetaBadge size="small" />
            </span>
          }
          icon={<AiIcon fontSize="small" />}
          resource={resource}
          disabled={false}
          handleClick={handleCreateAdvice}
        />
        <CreateMenuItem
          label="INBOUND"
          icon={<ContentAdd fontSize="small" />}
          resource={resource}
          handleClick={handleCreateShipment}
        />
      </Menu>
    </>
  );
};

export default CreateMenuButton;
